import React from 'react';
import { useTheme } from '../theme';
import cn from 'classnames';
export const Badge = props => {
    const css = useTheme('Badge').Badge;
    return React.createElement("span", { className: cn(css.badge, { [css.badge_active]: props.active }, props.className) }, props.value);
};
